import { render, staticRenderFns } from "./formulaire.form.component.vue?vue&type=template&id=2938ed96&"
import script from "./formulaire.form.component.vue?vue&type=script&lang=ts&"
export * from "./formulaire.form.component.vue?vue&type=script&lang=ts&"
import style0 from "./formulaire.form.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "formulaire.form.component.vue"
export default component.exports